import { render, staticRenderFns } from "./chart copy.vue?vue&type=template&id=1f28d2bd&scoped=true&"
import script from "./chart copy.vue?vue&type=script&lang=js&"
export * from "./chart copy.vue?vue&type=script&lang=js&"
import style0 from "./chart copy.vue?vue&type=style&index=0&id=1f28d2bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f28d2bd",
  null
  
)

export default component.exports